import { FC, useEffect, useState } from 'react';
import { Checkbox, Button } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import CancelIcon from '@mui/icons-material/Cancel';
import { ReportsCommand } from '../../../../services/command';
import { ReportsQuery } from '../../../../services/query';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import ListItemText from '@mui/material/ListItemText';
import { SSRS } from '../../ssrsPageManagement.classes';

interface IProps {
    selectedRow?: any;
    onCloseDialog?: any;
    roles?: any;
}
export const RoleManagementDialogContent: FC<IProps> = ({ selectedRow = null, onCloseDialog, roles }) => {
    const { t } = useTranslation();
    const [roleName, setRoleName] = useState<any[]>([]);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    useEffect(() => {
        GetReportByRole();
    }, []);
    const GetReportByRole = () => {
        ReportsQuery.GetListOfReportsAuthorization(selectedRow.reportId)
            .then((res: any) => {
                console.info(res);
                if (res) {
                    let arr: number[] = [];
                    res.data.map((item: any) => arr.push(item.roleId));
                    setRoleName(arr);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const handleDelete = (e: React.MouseEvent, value: string) => {
        e.preventDefault();
        setRoleName((current) => current.filter((item) => item !== value));
    };

    const _handlChangeMenu = (event: any) => {
        const {
            target: { value },
        } = event;
        setRoleName(typeof value === 'string' ? value.split(',') : value);
    };
    const submitHandler = (event: any) => {
        event.preventDefault();
        let params: any = {};
        params.ReportListId = selectedRow.reportId;
        params.RoleIds = roleName;
        ReportsCommand.UpdateAuthByRole(params).then(() => {
            Swal.fire(t('general.updated'), ' ', 'success');
            onCloseDialog();
        });
    };
    return (
        <div className={SSRS.roleDialogContentRoot} data-report-id={selectedRow?.reportId}>
            <form onSubmit={submitHandler} className={SSRS.roleDialogForm}>
                <DialogContent className={SSRS.roleDialogContent}>
                    <FormControl sx={{ m: 1, width: 400 }} className={SSRS.roleFormControl}>
                        <InputLabel id="parentMenuLabel">{t('menuManagement.roleList')}</InputLabel>
                        <Select
                            className={SSRS.inputRoleSelect}
                            sx={{ height: 'auto' }}
                            fullWidth
                            multiple
                            labelId="parentMenuLabel"
                            id="parentMenuLabel"
                            value={roleName}
                            renderValue={(selected) => (
                                <Box
                                    className={SSRS.roleChipsBox}
                                    sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
                                >
                                    {selected.map((roleId: any) => (
                                        <Chip
                                            key={roleId}
                                            className={SSRS.roleChip}
                                            data-role-id={roleId}
                                            label={roles?.find((e: any) => e.roleId === roleId).roleNameKey}
                                            clickable
                                            deleteIcon={
                                                <CancelIcon onMouseDown={(event: any) => event.stopPropagation()} />
                                            }
                                            onDelete={(e) => handleDelete(e, roleId)}
                                        />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                            label="Durumum"
                            onChange={(e) => _handlChangeMenu(e)}
                        >
                            {roles.map((role: any) => (
                                <MenuItem
                                    key={role.roleId}
                                    value={role.roleId}
                                    className={SSRS.roleMenuItem}
                                    data-role-id={role.roleId}
                                    data-role-name={role.roleNameKey}
                                >
                                    <Checkbox
                                        className={SSRS.roleMenuItemCheckbox}
                                        checked={roleName.indexOf(role.roleId) > -1}
                                    />
                                    <ListItemText className={SSRS.roleMenuItemText} primary={role.roleNameKey} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions className={SSRS.roleDialogActions}>
                    <Button
                        type="submit"
                        className={SSRS.btnRoleUpdate}
                        data-report-id={selectedRow?.reportId}
                    >
                        {t('general.update')}
                    </Button>
                    <Button onClick={onCloseDialog} className={SSRS.btnRoleCancel}>
                        {t('general.cancel')}
                    </Button>
                </DialogActions>
            </form>
        </div>
    );
};
